import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../../ui/Dialog/DialogActions";
import AddStudentForm from "./AddStudentForm";
import Button from "../../../../../../../../ui/Button";

const styles = theme => ({
  dialog: {
    width: "550px"
  }
});

const CreateNew = ({
  open,
  handleClose,
  createStudent,
  isCreatingStudent,
  masterClassName,
  createdStudent,
  classes,
  history
}) => {
  const [checked, setChecked] = React.useState(false);
  const [formData, updateFormData] = React.useState(null);

  const onConfirm = () => {
    createStudent(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>{`Записать студента на мастер-класс "${masterClassName}"`}</DialogTitle>
        <DialogContent>
          <AddStudentForm
            onFormChange={updateFormData}
            disabled={isCreatingStudent}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreatingStudent}
            disabled={isCreatingStudent}
            onClick={() => onConfirm()}
            color="green"
          >
            Добавить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(CreateNew));
